export const environment = {
  apiKey: '',
  apiUrl: 'https://api.genai-upcareer.store/',

  apiImagePath: ' ',
  envName: 'prod', // Environment name

  //For live version
  //apiUrl: 'https://api.upcareeraicv.com',
  //apiImagePath: 'https://api.upcareeraicv.com'
};
